<script>
    import { user, game, view, send_request} from "../client.svelte.js";
    import {timestamp, token_URL} from '../core.js'
    import CombatTab from "./CombatTab.svelte";
    import SkillsTab from "./SkillsTab.svelte";
    import PowersTab from "./PowersTab.svelte";
    import EquipTab from "./EquipTab.svelte";
    import StateTab from "./StateTab.svelte";
		import {scroll_to} from "../play/Encounter.svelte";
    import Select from "../elements/Select.svelte";

    let allTabs = [{label: "Aktionen", help: "combat", component: CombatTab, color: "darkred"},
                   {label: "Fertigk", help: "skills", component: SkillsTab, color: "darkgreen"},
                   {label: "Kräfte", help: "powers", component: PowersTab, color: "darkblue"},
                   {label: "Ausrüst", help: "equip", component: EquipTab, color: "black"},
                   {label: "Zustand", help: "state", component: StateTab, color: "black"}]
    let tabs = $derived((user.isMaster) ? allTabs : allTabs.filter(tab => ['Fertigk', 'Kräfte', 'Ausrüst'].includes(tab.label) || (tab.label === 'Aktionen' && game.mode === 'combat')))	// visible tabs
    let selectedTab = $state((game.mode === 'combat' || game.mode === 'script') ? allTabs[0] : (game.mode === 'recon') ? allTabs[1] : allTabs[3])

    function switch_tab(tab) { return () => selectedTab = tab }

    let healthGauge, focusGauge     // SVG elements for the life and focus gauge
    const injurColors = ["rgb(0,160,0)", "rgb(220,200,0)", "rgb(220,120,0)", "rgb(220,0,0)", "black"]
    const moraleColors = ["#1E90FFFF", "#b41fff"]
    let commentInput = $state()

		// component state variables
    let affects = $derived(view.persona.affects.map(effID => game.effects.get(effID)).filter(eff => eff))
    let buffs = $derived(affects.filter(eff => ['buff', 'heal', 'save'].includes(eff.kind)))
    let nerfs = $derived(affects.filter(eff => ['harm', 'nerf'].includes(eff.kind) || (eff.kind === 'hurt' && eff.severity)))
    let life = $derived(view.persona.vital - view.persona.damage)
    let foc = $derived(Math.round(view.persona.focus - view.persona.exhaustion))
		let bruiseDam = $derived.by( () => {
			const bruises = affects.filter(eff => eff.kind === 'hurt' && eff.severity === '').map(eff => eff.damage)
			const damSum = bruises.reduce((accum,current) => accum + current, 0)
			return (damSum > 0) ? `${bruises.length} P: ${damSum} LPV` : null
		})

    const calc_hint = (eff) => eff.summary + ((user.isMaster) ? ` (bis ${timestamp(eff.end)})` : "")

    // $inspect("CONTROLLER - affects", affects)

		$effect(() => {
        /// calculate percentages for circle segment diplay
        let healthStat = Math.max(0, view.persona.life / view.persona.vital)
        let focusStat = Math.max(0, foc / view.persona.focus)
				const injurs = Math.min(nerfs.reduce((count, eff) => count + ((eff.severity === 'V') ? 1 : 0), 0), 4)
        const gaugeCircum = healthGauge.r.baseVal.value * 2 * Math.PI;
        healthGauge.style.strokeDashoffset = gaugeCircum * (1 - healthStat / 2)
        healthGauge.style.stroke = injurColors[injurs]
        focusGauge.style.strokeDashoffset = gaugeCircum * (1 + focusStat / 2)
				focusGauge.style.stroke = moraleColors[(view.persona.focus < 0) ? 1 : 0]
    })

    /// personas that player can play

    let playables = $derived(game.playables.map(persID => game.personas.get(persID)))
    let altRole = $derived.by(() => {
        if (game.playables.length > 2)
						return 'default'
        else if (game.playables.length === 2)
						return (game.playables[0] === view.persona.ID) ? game.playables[1] : game.playables[0]
        else
            return null
    })

    function select_persona(e) {
				const persID = e.target.value
	      view.select_persona(persID)
    }


		/** updates all character data */
		export function set_attr(charData) {

		}


		/** character makes comment */
    function communicate(comment) {
        if (!comment) return
        if (comment instanceof Event)  comment = comment.target.value
        // parse comment for targeted communication
        let action = "", aim = ""
        if (comment.includes("^")) comment = comment.replace("^", view.persona.name)
        if (comment.charAt(0) === "@") {
            [aim, comment] = comment.split(":", 2)
            aim = aim.slice(1).trim()
            comment = comment.trim()
        }
        // check if user wants to report an error, shout or comment
        let data = {}
        if (comment.charAt(0) === "#") {
            action = "ISSUE " + document.getElementById("action").value
            comment = comment.slice(1).trim()
            data['aim'] = document.getElementById("aim").value
        } else if (comment.charAt(0) === "!") {
            action = 'Ruf'
            comment = comment.slice(1).trim()
        } else if (comment.charAt(0) === "$" && user.isMaster) {
            action = 'Ereignis'
        } else
            action = 'Meinung'
        if (!comment) comment = "Äh,..."
        Object.assign(data, {action: action.trim(), subject: view.persona.ID, text: comment})
        console.log(`CONTROL: Communication as ${action} with ${comment}`, data)
        if (action === 'Meinung')
            send_request('message', data)
        else
            send_request('order', data)
        commentInput.value = ""     //ToDo: can we use this here?
		}

    function clickon_portrait() {
				scroll_to(view.persona.position, true)
		}

		function show_character(e) {
				view.select_character(view.persona.character)
				if (view.character.ZUB === 'Hero')
						view.switch_layout('hero-abils')
				else
						view.switch_layout('advt-charDetails')
		}

		function trigger_evaluate(e) {
				e.preventDefault()
				if (user.isMaster)
						send_request('evaluate', {})
    }


		function show_effect(e) {
				if (view.dialog?.props?.modal && e.type === 'click')
					view.close_dialog()
				else if (!view.dialog || e.type === 'click') {
						const coord = {x: e.clientX + 12, y: e.clientY + 36}
						view.show_dialog('effect', {effect: this, coord: coord, modal: e.type === 'click'})
				}
		}

		function close_effect(e) {
				if (view.dialog?.type === 'effect' && !view.dialog.props.modal)
						view.close_dialog()
		}

    function stop_effect(e) {
				e.preventDefault()
        if (user.isMaster || ['Hidden', 'Watchful'].includes(this.type)) {
            const coord = {x: e.clientX, y: e.clientY}
            // console.log(`CONTROLLER: Show menu to stop effect ${this.effect} (${this.type}) with this = `, this)
						const instructions = [{instruct: 'REMOVE', label: "entfernen", subject: view.persona.ID, target: this.ID}]
						if (this.ZUB === 'DynamicEffect')
								instructions.push({instruct: 'SUSPEND', label: "anhalten", subject: view.persona.ID, target: this.ID})
            view.show_dialog('options', {coord: coord, options: {Effekt: instructions}})
        }
		}
</script>


<!------------------------------- HTML ------------------------------------->

<div id='Controller' data-help="controller" class=controllerPanel class:masterView={user.isMaster} class:playerView={!user.isMaster}>
	<div class="role" data-help="role">
		{#if playables.length <= 2}
			<h3>{view.persona.name}</h3>
			{#if altRole}
				<img id=altRole src={game.personas.get(altRole).tokenURL} alt={altRole} onclick={() => view.select_persona(altRole)}>
			{/if}
		{:else}
			<Select field='role' value={view.persona.ID} options={playables} unlabeled onchange={select_persona}
							style="font-size: x-large; font-weight: bolder; text-align: center; width: 94%" />
		{/if}
	</div>

	<!--- character info box --->
	<div id="charInfo">
		<svg id="charCanvas">
			<circle id="healthGauge" data-help="life" class="gauge" bind:this={healthGauge} r="44" cx="48" cy="48"></circle>
			<circle id="focusGauge" data-help="focus" class="gauge" bind:this={focusGauge} r="44" cx="48" cy="48"></circle>
		</svg>
		<img id=charPortrait data-help="controller" class="button" src={view.persona.tokenURL} alt={view.persona.ID}
				 onclick={clickon_portrait} ondblclick={show_character} oncontextmenu={trigger_evaluate}/>
		<p id="life">{view.persona.life}</p>
		<p id="focus">{foc}</p>
		{#if user.equipments.get(view.persona.equipment)?.missile}
			<img id='missile' src="/static/images/Pfeil%20einlegen.png" alt="missile">
		{/if}
		<div id="nerfs" data-help="effects">
			{#each nerfs as eff}
				<p class={eff.kind} title="{calc_hint(eff)}"
					 onmouseenter={show_effect.bind(eff)} onmouseleave={close_effect.bind(eff)}
					 oncontextmenu={stop_effect.bind(eff)} onclick={show_effect.bind(eff)} >
					{eff.effect}
				</p>
			{/each}
			{#if bruiseDam}
				<p class="hurt">{bruiseDam}</p>
			{/if}
		</div>
		<div id="buffs" data-help="effects">
			{#each buffs as eff}
				<p class={eff.kind} title="{calc_hint(eff)}" onmouseenter={show_effect.bind(eff)} onmouseleave={close_effect.bind(eff)}
					 oncontextmenu={stop_effect.bind(eff)} onclick={show_effect.bind(eff)} >
					{eff.effect}
				</p>
			{/each}
		</div>
	</div>

	<!--- communication box --->
	<div id="commentBox" data-help="comment" class="activityarea">
        <input bind:this={commentInput} data-help="comment" type=text class="text" onchange={communicate}
               placeholder="Kommentar (Ausruf beginnt mit '!', flüstern mit '@')">
	</div>

	<div class="viewTabselect-clip" class:high={tabs.length > 3}>
		<ul id="viewTabselect">
			{#each tabs as item}
				<!-- svelte-ignore a11y_click_events_have_key_events, a11y_no_noninteractive_element_interactions -->
				<li class="button viewTab" data-help={item.help} class:selected={selectedTab.label === item.label} onclick={switch_tab(item)}>
					{item.label}
				</li>
			{/each}
		</ul>
	</div>
	<selectedTab.component />
</div>


<!------------------------------- STYLE ------------------------------------->

<style lang="sass">
	@use "../colors" as colors

	.controllerPanel
		flex: 0 0 420px
		position: relative
		overflow: auto
		scrollbar-width: none  /* for Firefox */
		background: black url("/static/images/background-light.png")

		&.masterView
			--topPadding: 72px

		&.playerView
			flex: 0 0 380px
			--topPadding: 0px

	.role
		position: relative
		left: var(--menu-width)
		width: calc(var(--panel-width) - var(--menu-width))
		text-align: center

		h3
			width: 60%
			font-size: x-large
			font-weight: bolder

		img
			position: absolute
			width: 48px
			right: 4px
			top: -10px


	#charInfo
		position: relative
		height: 145px
		background: #222222 url("/static/images/background-noise.png")

	#charName
		width: 100%
		margin: 0
		text-align: center

	#charCanvas
		position: absolute
		top: 12px
		left: calc(50% - 48px)
		height: 96px
		width:  96px

	#charPortrait
		position: absolute
		top: 20px
		left: calc(50% - 40px)
		width: 80px
		height: 80px
		background: rgb(60,60,60)
		border-radius: 50%

	#life
		position: absolute
		top: 90px
		left: 132px
		width: 2ch
		/*background-color: green*/
		text-align: center

	#focus
		position: absolute
		top: 90px
		right: 132px
		width: 2ch
		/*background-color: dodgerblue*/
		text-align: center

	#missile
		position: absolute
		top: 110px
		left: 192px
		width: 28px
		rotate: 45deg

	.playerView #missile
		left: 174px

	.gauge
		/*cx: 48px*/
		/*cy: 48px*/
		/*r:  44px*/
		transition: 0.35s stroke-dashoffset
		transform: rotate(90deg)
		transform-origin: 50% 50%
		fill: none

	#healthGauge
		stroke: green
		stroke-width: 8px
		stroke-dasharray: 276
		stroke-dashoffset: 138

	#focusGauge
		stroke: dodgerblue
		stroke-width: 8px
		stroke-dasharray: 276
		stroke-dashoffset: 414


	#nerfs
		position: absolute
		bottom: 0
		left: 0
		width: 120px
		background: red
		padding: 0 4px
		text-align: center

	#buffs
		position: absolute
		bottom: 0
		right: 0
		width: 120px
		background: green
		padding: 0 4px
		text-align: center

	.buff
		background: darkgreen

	.nerf
		background: darkred

	.damage
		background: darkorange


	/**** CHARACTER comments ****/

	#occuranceBtn img
		width: 24px

	.viewTabselect-clip
		height: 35px
		overflow: hidden

	.viewTabselect-clip.high
		height: 65px

	#viewTabselect
		display: flex                  /* establish flex container */
		flex-flow: row wrap
		justify-content: space-around  /* switched from default (flex-start, see below) */
		list-style-type: none
		margin-block: 0        /* undo UL styles */
		padding-inline: 0
		border-bottom: 3px solid colors.$primary-060-black
		position: relative
		gap: 5px
		margin-top: 50px

	.viewTab
		//width: 100px
		padding: 5px 15px 10px 15px
		flex: 1
		//border: 1px dashed lightgrey
		border-radius: 10px 10px 0 0
		text-align: center
		cursor: pointer
		transition: 0.5s
		color: white
		background-color: colors.$grey-20
		filter: drop-shadow(0 0 2px black)
		height: 70px
		min-width: 100px
		margin-top: -45px
		position: relative

	//.viewTab:nth-child(n+2)
	//	margin-left: 20px

	.viewTab:hover
		filter: brightness(100%)
		background-color: colors.$primary-100

	.viewTab.selected
		background-color: colors.$grey-50
		font-weight: 600
		color: black

	.viewTab.selected:hover
		filter: none
		background-color: colors.$primary-060-black


	/**** CHARACTER combat ****/

	.activityarea
		border-radius: 10px
		border: 2px solid black
		box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
		margin: 6px
		break-inside: avoid

	.masterView .actdata
		grid-template-columns: 3fr 2fr 4ch

	.playerView .actdata
		grid-template-columns: 3fr 2fr

	.vertical
		width: auto
		height: auto
		margin: 8px 8px 8px 16px
		/*writing-mode: vertical-lr*/
		/*text-orientation: mixed*/

	#combatTab
		background-color: darkred

	#skillsTab
		background-color: darkgreen

	#powersTab
		background-color: darkblue

	#gearTab
		background-color: black

	/* content of the skills and powers tab (SkillsTab, PowersTab) */
	.controllerPanel :global(.tabContent)
		padding: 5px
		background-color: colors.$grey-50

		:global(tr:nth-child(even) td)
			background-color: colors.$grey-15

		:global(tr:nth-child(odd) td)
			background-color: colors.$grey-20

		:global(thead)
			background-color: colors.$primary-060-black
			font-style: italic

		:global(table), :global(th), :global(td)
			border: none
			outline: none
			border-collapse: collapse

		:global(td)
			padding: 5px 5px

		:global(h3)
			background-color: colors.$primary-040-black
			padding: 5px 0
			margin-bottom: 0
			text-align: center
			border-radius: 15px 15px 0 0

	#commentBox
		margin-bottom: 16px

	#commentBox input
		background-color: black
</style>